import { FC } from "react";
import Camera from "../../UI/camera/Camera";
import { useAppSelector } from "../../../hooks/ReduxHooks";

interface IIdentificationProps {
  isFaceControl: boolean;
  setFrontPassportPhoto: Function;
  setBackPassportPhoto: Function;
}

const Identification: FC<IIdentificationProps> = ({
  isFaceControl,
  setBackPassportPhoto,
  setFrontPassportPhoto,
}) => {
  const faceResult = useAppSelector((state) => state.user.compareFacesResult);

  return (
    <div className="flex w-full justify-center">
      {!faceResult && (
        <Camera
          isFaceControl={isFaceControl}
          setBackPassportPhoto={setBackPassportPhoto}
          setFrontPassportPhoto={setFrontPassportPhoto}
        />
      )}
    </div>
  );
};

export default Identification;
